export default {
    // 获取url中的参数值
    getUrlParams(url) {
        let urlStr = url.split('?')[1] || ''
        let obj = {};
        let paramsArr = urlStr.split('&')
        for (let i = 0, len = paramsArr.length; i < len; i++) {
            const num = paramsArr[i].indexOf('=')
            let arr = [paramsArr[i].substring(0, num), paramsArr[i].substring(num + 1)]
            obj[arr[0]] = arr[1];
        }
        return obj
    }
}